import { render, staticRenderFns } from "./BedTagsManagement.vue?vue&type=template&id=077a55ab&scoped=true&"
import script from "./BedTagsManagement.vue?vue&type=script&lang=js&"
export * from "./BedTagsManagement.vue?vue&type=script&lang=js&"
import style0 from "./BedTagsManagement.vue?vue&type=style&index=0&id=077a55ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a55ab",
  null
  
)

export default component.exports